import { NOTIFICATION_TARGET } from "../constants";

const FALLBACK_PATH = "/dashboard";

const buildContractorChatPath = (tenderId) =>
  `/dashboard/contractor/ongoing/tasks/${tenderId}?tab=Communication`;

const buildClientChatPath = (tenderId) =>
  `/dashboard/ongoing-tender-details/${tenderId}?tab=Communication`;

const TENDER_CHAT_PATH_BY_USER_TYPE = {
  contractor_admin: buildContractorChatPath,
  contractor_owner: buildContractorChatPath,
  contractor_manager: buildContractorChatPath,
  client: buildClientChatPath,
  client_member: buildClientChatPath,
};

function normalizeUserType(userType) {
  return String(userType ?? "")
    .trim()
    .toLowerCase();
}

function resolveTenderChatPath(userType, tenderId) {
  if (!tenderId) return null;

  const normalized = normalizeUserType(userType);
  const build = Object.prototype.hasOwnProperty.call(TENDER_CHAT_PATH_BY_USER_TYPE, normalized)
    ? TENDER_CHAT_PATH_BY_USER_TYPE[normalized]
    : null;

  return build ? build(tenderId) : FALLBACK_PATH;
}

function resolveProjectPath(projectId, hasProjectAccess) {
  if (!projectId || !hasProjectAccess) return null;

  return `/dashboard/projects/${projectId}`;
}

const DESTINATION_RESOLVERS = {
  [NOTIFICATION_TARGET.TENDER_CHAT]: ({ userType, tenderId }) =>
    resolveTenderChatPath(userType, tenderId),
  [NOTIFICATION_TARGET.PROJECT]: ({ projectId, hasProjectAccess }) =>
    resolveProjectPath(projectId, hasProjectAccess),
};

export function resolveNotificationDestination(target, context = {}) {
  const resolver = DESTINATION_RESOLVERS[target];
  return resolver ? resolver(context) : null;
}
